import useMediaQuery from '@material-ui/core/useMediaQuery';
import { BREAKPOINT_MD_SIZE } from '@alltrails/shared/denali/tokens';

const useIsMobileSizedScreen = () => useMediaQuery(`(max-width: ${BREAKPOINT_MD_SIZE}px)`);

export default useIsMobileSizedScreen;
